/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../lib/@waca/dashboard-common/dist/glass/controllers/WidgetBaseActionHandler',
	'../widgets/livewidget/nls/StringResources',
	'../DynamicFileLoader'
], function(BaseClass, stringResources, DynamicFileLoader) {
	'use strict';

	/**
	 * Glass Action controller which loads visualizations
	 * based on the LiveWidget using the LiveWidgetUIHelper
	 */
	const ActionHandler = BaseClass.extend({

		getOptions: function(context) {
			const view = this._getDashboardView(context);
			const dashboardApi = view.getDashboardApi();
			const options = {
				className: 'visualizationSlideout',
				dashboardApi: dashboardApi,
				services: view.services, // TODO: remove once core is using the dashboardApi
				title: stringResources.get('visualizationSlideoutTitle'),
				module: 'dashboard-analytics/visualizationPanel/VisualizationPanelView',
				getEntries: this.getEntries.bind(this, context)
			};
			return Promise.resolve(options);
		},

		getEntries: function(context) {
			return this.createWidgetAddUIHelper(context)
				.then(helper => helper.getEntries())
				.then(this.getSpecs.bind(this, context));
		},

		getSpecs: function(context, entries) {
			return this.createWidgetAddUIHelper(context).then(helper => {
				const spec = {};

				const options = {
					onItemClick: (widget, event) => {
						return helper.addWidgetBySelection(widget, event, {
							selectOptions: {
								flyout: false
							}
						});
					},
					onItemStartDrag: helper.addWidgetByDrag.bind(helper)
				};

				spec.options = options;
				spec.items = entries;

				return spec;
			});
		},

		// Private

		_getDashboardView: function(context) {
			return context.glassContext.appController.currentAppView.currentContentView;
		},

		_getUiHelperClass: function() {
			return DynamicFileLoader.load(['dashboard-analytics/widgets/livewidget/LiveWidgetUIHelper'])
				.then(function(modules) {
					return modules[0];
				}.bind(this));
		},

		createWidgetAddUIHelper: function(context) {
			const view = this._getDashboardView(context);

			return this._getUiHelperClass().then(function(HelperClass) {
				const helper = new HelperClass({
					dashboardApi: view.getDashboardApi(),
					services: view.services // TODO : remove once the common add ui helper is not using the services.
				});

				helper.panelAttributes = {
					dashboardApi: view.dashboardApi,
					cdnUrl: view.getCDNUrl(),
					ajaxSvc: view.ajaxSvc
				};

				return helper;
			});
		}

	});

	return ActionHandler;
});
